const formatFilter = function (filter) {
    if (filter) {
        const prefix = filter.isExclude ? 'NOT ' : '';
        return prefix + filter.label + filter.operator + filter.value;
    }
};

export default formatFilter;